import { AppUtils } from '../../shared/utils/index';

/**
 * Builds typical urls used in applications.
 */
export class BasicApplicationUrlBuilder<T extends BasicAppDefinition> {

	constructor(options: BasicAppOptions<T>) {
		const obsoletOpts = options as BasicAppOptions<T> & { app: { apilogin: string } };
		T.Utils.Auth.authorizeURL = T.Utils.Auth.authorizeURL || options.app.apiauth || obsoletOpts.app.apilogin;
		T.Utils.Auth.registerURL = T.Utils.Auth.registerURL || options.app.apiregister;
		T.Utils.Application.api = T.Utils.Auth.api = T.Utils.Auth.api || AppUtils.View.getMetaValueByKey("backend");
		T.Utils.Application.client = T.Utils.Auth.client = T.Utils.Auth.client || AppUtils.View.getMetaValueByKey("client");
		T.Utils.Auth.redirectUri = T.Utils.Auth.redirectUri || AppUtils.View.getMetaValueByKey("redirect_uri");
		T.Utils.Application.apim = T.Utils.Application.apim || AppUtils.View.getMetaValueByKey("backendapim");
		T.Utils.Application.apimSubscriptionKey = T.Utils.Application.apimSubscriptionKey || AppUtils.View.getMetaValueByKey("apimsubsriptionkey");
	}

	/**
	 * Adds the api host to the provided relative url.
	 */
	public fullUrl(relativeUrl: string): string {
		return AppUtils.Url.combine(T.Utils.Auth.api, relativeUrl);
	}

	/* istanbul ignore next: wrapper function */
	public fullApimUrl(relativeUrl: string): string {
		return AppUtils.Url.combine(T.Utils.Application.apim, relativeUrl);
	}

	/**
	 * Builds a login url that ends at the provided process url. If no process url is provided, the process ends at the current page url.
	 */
	public async loginUrl(): Promise<string> {
		return T.Utils.Auth.makeAuthorizeURL();
	}

	/* istanbul ignore next: wrapper function */
	public async registerUrl(): Promise<string> {
		return T.Utils.Auth.makeRegisterURL();
	}

	/* istanbul ignore next: wrapper function */
	public async logoutUrl(redirectUrl?: string): Promise<string> {
		return T.Utils.Auth.makeLogoutURL(redirectUrl ? { redirect_uri: redirectUrl } : null);
	}
}
